import qwest from 'qwest';
import {createSearchParams} from 'helpers/searchParams';
import {trublueMemberIDEnabled} from 'features';

let onSuccess = () => {
  return (xhr, response) => {
    if (response.success) {
      return response.data;
    }
    throw response;
  };
};

let onError = () => {
  throw {
    code: -1,
    data: null,
    message: 'Unexpected Error',
    success: false,
  };
};

let ReportApi = {
  getFollowUpReport(start, end) {
    return qwest.post(`v1/newReports/FollowUp/FollowUpReport?start=${start}&end=${end}`)
      .then(onSuccess(), onError);
  },
  getFollowUpReportExport(locale, start, end) {
    window.open(`v1/newReports/FollowUp/FollowUpReportExport?locale=${locale}` +
      `&start=${start}&end=${end}`);
  },

  getWaterTotalAnalyses(dateFrom, dateTo, branch, systemType) {
    return qwest.get(`v1/newReports/WaterAnalyses/Summary?start=${dateFrom}&end=${dateTo}&store=${branch}&systemType=${systemType}`)
    .then(onSuccess(), onError);
  },

  getWaterTotalAnalysesExport(locale, dateFrom, dateTo, branch, systemType) {
    window.open(`v1/newReports/WaterAnalyses/ExportReport?start=${dateFrom}&end=${dateTo}&store=${branch}&systemType=${systemType}&locale=${locale}`);
  },

  getWaterTrublueClaims(dateFrom, dateTo, search, status, page = 1, count = 20) {
    return qwest.get(`TruBlueClaims/?start=${dateFrom}&end=${dateTo}&search=${search || ''}&status=${status}&page=${page}&pageSize=${count}`)
    .then(onSuccess(), onError);
  },

  getWaterTrublueClaimsExport(locale, dateFrom, dateTo, search, status) {
    window.open(`TruBlueClaims/ExportReport?start=${dateFrom}&end=${dateTo}&search=${search || ''}&status=${status}&locale=${locale}&isTruBlueMemberIDEnabled=${trublueMemberIDEnabled}`);
  },

  getWaterTrublueClaim(id, locale) {
    return qwest.get(`TruBlueClaims/Claim?claimID=${id}&locale=${locale}`)
    .then(onSuccess(), onError);
  },

  saveWaterTrublueClaim(claim) {
    return qwest.post('TruBlueClaims/Save', claim)
    .then(onSuccess(), onError);
  },

  saveWaterTrublueClaimInvoice(claim, file, result) {
    return qwest.post('TruBlueClaims/AddFile', {
      claimID: claim.ID,
      filename: file.name,
      invoice: result,
    })
    .then(onSuccess(), onError);
  },

  deleteWaterTrublueClaimInvoice(claim, attachment) {
    return qwest.delete(`TruBlueClaims/DeleteFile?ClaimID=${claim.ID}&attachment=${attachment}`)
    .then(onSuccess(), onError);
  },

  getWaterAnalysesByEmployeeSummary(dateFrom, dateTo, branch) {
    return qwest.get(`v1/newReports/water/AnalysesByEmployee/Summary?start=${dateFrom}&end=${dateTo}&store=${branch}`)
      .then(onSuccess(), onError);
  },

  getWaterAnalysesByEmployeeExport(locale, dateFrom, dateTo, branch) {
    window.open(`v1/newReports/water/AnalysesByEmployee/ExportReport?start=${dateFrom}&end=${dateTo}&store=${branch}&locale=${locale}`);
  },

  getOutboundEmailsSummary(dateFrom, dateTo, branch) {
    return qwest.get(`v1/newReports/communications/OutboundEmails/Summary?start=${dateFrom}&end=${dateTo}&store=${branch}`)
      .then(onSuccess(), onError);
  },

  getSeasonsUsageReportPDFGeneration(branch = null, truBlueStatus = null, active = 'all') {
    return qwest.get(`v1/newReports/BioGuard/SeasonsUsageReportPDFGeneration${createSearchParams({
      branch, truBlueStatus, active,
    })}`)
      .then(onSuccess(), onError);
  },

  getSeasonsUsageReportPDFHistory() {
    return qwest.get(`v1/newReports/BioGuard/SeasonsUsageReportPDFHistory`)
      .then(onSuccess(), onError);
  },

  getScheduledReportDetails(reportIDs) {
    if (typeof reportIDs === 'object') {
      reportIDs = reportIDs.join('&reportIDs=');
    }

    const url = `v1/newReports/ScheduledReport/GetReportDetails?reportIDs=${reportIDs}`;

    return qwest.get(url).then(onSuccess(), onError);
  },
};

export default ReportApi;
